'use client'
import { useState, useEffect, useMemo } from "react";
import { decode, encode } from "@/src/utils/coder";
import type { Menu } from "@/src/types/menu.types";
import { BuildRouteMap, APIRouter } from "@/src/utils/router";
import HeadNav from "@/src/components/HeadBar";
import authMenu from "@/src/auth.menu.json";
import menu from "@/src/menu.json";
import Sidebar from "@/src/app/dashboard/Sidebar";
import Hero from "@/src/app/dashboard/Hero";
import Corps from "./Corps";
import EditorTable from "@/src/components/Table/EditorTable";
import type { ServiceModule } from "@/src/types/api.types";
import TitleBar from "@/src/components/TitleBar";

const routeMap = BuildRouteMap({
  ...authMenu as Menu,
  ...menu as Menu
});

const homePage = (
  <div className="container">
    <Hero />
    <Corps />
  </div>
);

const resetHomePage = () => {
  localStorage.setItem("selected", JSON.stringify({}));
};

const DEFAULT_HIERARCHY = ["Table", "Page"];

export default function DashboardPageOne({ searchParams }: {
  searchParams?: Promise<{ c?: string; p?: string }>;
}) {
  const [apiCall, setApiCall] = useState<ServiceModule>();
  const [hierarchy, setHierarchy] = useState<string[]>(DEFAULT_HIERARCHY);

  const page = useMemo(
    () => apiCall ? <EditorTable title={hierarchy.at(-1)??""} apiCall={apiCall} /> : homePage,
    [apiCall, hierarchy]
  );

  useEffect(() => {
    let isCurrent = true;
    
    const load = async () => {
      const params = await searchParams;
      if (!isCurrent) return;

      if (!params) {
        resetHomePage();
        setApiCall(undefined);
        return;
      }

      setHierarchy(decode(params.c ?? encode(DEFAULT_HIERARCHY.join('>')))?.split('>'));      
    
      const pResult: ServiceModule | undefined = await APIRouter(params, routeMap);
      if (!isCurrent) return;

      if (pResult) {
        setApiCall(pResult);
        return;
      }

      resetHomePage();
      setApiCall(undefined);
    };

    void load();

    return () => {
      isCurrent = false;
    };
  }, [searchParams]);

  return (
    <div className="d-flex min-vh-100">
      <Sidebar />
      <div
        className="position-fixed d-flex flex-column vh-100"
        style={{ left: '270px', right:0}}
      >
        <HeadNav
          title={`${hierarchy[0]} Page`}
          name="Rizky Hardyhatmoko"
          designation="Accounting Manager"
          url="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100&h=100"
        />
        <TitleBar title={hierarchy.length === 1 && hierarchy[0] === "" ? DEFAULT_HIERARCHY : hierarchy} />
        <main className="grow overflow-auto bg-red" style={{ minHeight: 0 }}>
          {page}
        </main>
      </div>
    </div>
  );
}
